import { RightOutlined } from '@ant-design/icons';
import { buriedPoint } from '@lcsc-ui/utils/buriedPoint';
import { Autoplay, Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import 'swiper/css/navigation';

const typeFn = (obj) => {
  if (obj?.isGlobal === 'yes') {
    return '全站';
  } else if (obj?.productCodes) {
    return '商品';
  } else if (obj?.productTypeManagerIds) {
    return '目录';
  } else if (obj?.productGradePlateIds) {
    return '品牌';
  }
  return '';
};

const activityTypeMap = {
  coupont: '送券',
  reduce: '满减',
  freight_free: '包邮',
  full_give: '满赠',
  discount: '折扣',
  activity: '活动',
  collar_sample: '领样',
  exchange: '兑换',
  rebate: '返利',
  promotion: '促销',
  clearance: '清仓',
  collage: '拼团',
  seckill: '秒杀',
  explain: '说明',
  redemption: '换购',
};

export default function ProductNotice({ data }) {
  const toPage = (item) => {
    // window.open(item.activityLink);
    // 埋点方法
    let cp = '';
    let op = '';
    if (data.isMro) {
      cp = 'mro_product_detail';
      op = 'mro_swap_link';
    } else {
      cp = 'product_detail';
      op = 'swap_link';
    }
    if (item.activeType === 'redemption') {
      // 换购埋点
      buriedPoint({
        cp,
        ty: 'click',
        op,
        data: {
          activeName: item.activeName,
        },
      });
    } else {
      buriedPoint({
        pf: 'pc',
        ty: 'click',
        cp: 'product_detail',
        op: 'full_site',
      });
    }
  };

  return (
    <div className="w-[400px] mt-[16px] mb-[20px]">
      <Swiper
        direction="vertical"
        navigation={false}
        modules={[Navigation, Autoplay]}
        loop
        autoplay={{ delay: 3000, disableOnInteraction: false }}
        className="h-[20px] text-[12px]"
      >
        {(data?.promotionActivityList || []).map((item, index) => (
          <SwiperSlide className="lc-mb-0 cursor-pointer" key={index}>
            <a
              href={item.activityLink}
              rel="nofollow"
              aria-label={`${typeFn(item)}${activityTypeMap[item.activityType]}`}
              onClick={() => toPage(item)}
              ignore-spm
            >
              <ul className="flex items-center">
                <li>
                  <ul className="flex items-center w-[62px] rounded-[4px] border-[1px] border-solid border-[#FF7800]">
                    <li className="text-white bg-[#FF7800] w-[31px] text-center">{typeFn(item)}</li>
                    <li className="text-[#FF7800] w-[31px] text-center">{activityTypeMap[item.activityType]}</li>
                  </ul>
                </li>
                <li className="ml-[10px] flex items-center">
                  <span className="text-[#56657F]">{item.promotionActivityName}</span>
                  <span className="ml-[5px] mr-[4px] text-[#0093E6]">
                    详情 <RightOutlined />
                  </span>
                </li>
              </ul>
            </a>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}
